(() => {
  if (window.ppSkullokPurchaseReady) return;
  window.ppSkullokPurchaseReady = true;
  const selector = 'product-form[data-optional-plate="true"]';
  const getForm = root => root?.querySelector('form');
  const checkboxFor = form => Array.from(document.querySelectorAll('[data-pp-plate-checkbox]')).find(box => box.getAttribute('form') === form.getAttribute('id') || box.form === form);
  function state(root) {
    const form = getForm(root);
    if (!form) return null;
    const box = checkboxFor(form);
    const quantityInput = form.elements.namedItem('quantity');
    const quantity = Number(quantityInput?.value || 1);
    return {form, box, quantity, selected: !!(box?.checked && !box.disabled), button: root.querySelector('button[type="submit"]')};
  }
  function update(root) {
    const s = state(root);
    if (!s || !s.button || s.button.disabled || root.dataset.ppBusy) return;
    const amount = (Number(root.dataset.basePrice) + (s.selected ? Number(s.box.dataset.price) : 0)) * s.quantity / 100;
    const price = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:root.dataset.currency || 'USD'}).format(amount);
    s.button.querySelector('span').textContent = (s.selected ? root.dataset.bothLabel : root.dataset.soloLabel) + ' — ' + price;
  }
  function updateAll() { document.querySelectorAll(selector).forEach(update); }
  async function purchase(root) {
    const s = state(root);
    if (!s || root.dataset.ppBusy || s.button.disabled) return;
    if (!Number.isInteger(s.quantity) || s.quantity < 1 || !s.form.reportValidity()) return;
    root.dataset.ppBusy = 'true';
    s.button.setAttribute('aria-disabled','true');
    s.button.classList.add('loading');
    const spinner = root.querySelector('.loading__spinner');
    spinner?.classList.remove('hidden');
    const wrapper = root.querySelector('.product-form__error-message-wrapper');
    const message = root.querySelector('.product-form__error-message');
    if (wrapper) wrapper.hidden = true;
    const data = new FormData(s.form);
    const properties = {};
    for (const [key,value] of data.entries()) {
      if (key.startsWith('properties[')) properties[key.slice(11,-1)] = value;
    }
    const mount = {id:Number(data.get('id')), quantity:s.quantity};
    if (Object.keys(properties).length) mount.properties = properties;
    const items = [mount];
    if (s.selected) items.push({id:Number(s.box.dataset.variantId),quantity:s.quantity});
    const drawer = document.querySelector('cart-drawer');
    const sectionIds = drawer?.getSectionsToRender?.().map(section => section.id) || [];
    const payload = {items};
    if (sectionIds.length) Object.assign(payload,{sections:sectionIds,sections_url:window.location.pathname});
    const base = window.Shopify?.routes?.root || '/';
    try {
      const response = await fetch(base + 'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || root.dataset.errorMessage);
      root.dataset.cartMountQuantity = String(Number(root.dataset.cartMountQuantity || 0) + s.quantity);
      if (drawer && result.sections && sectionIds.every(id => result.sections[id])) {
        drawer.setActiveElement?.(s.button);
        drawer.classList.remove('is-empty');
        try { drawer.renderContents({...result,id:result.items?.[0]?.id}); }
        catch { window.location.assign(base + 'cart'); }
      } else {
        window.location.assign(base + 'cart');
      }
    } catch (error) {
      if (message) message.textContent = error.message || root.dataset.errorMessage;
      if (wrapper) wrapper.hidden = false;
    } finally {
      delete root.dataset.ppBusy;
      s.button.removeAttribute('aria-disabled');
      s.button.classList.remove('loading');
      spinner?.classList.add('hidden');
      update(root);
    }
  }
  document.addEventListener('change', updateAll, true);
  document.addEventListener('input', event => {
    if (event.target.name === 'quantity' || event.target.matches?.('[data-pp-plate-checkbox]')) updateAll();
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest?.(selector + ' button[type="submit"]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    purchase(button.closest(selector));
  }, true);
  document.addEventListener('submit', event => {
    const root = event.target.closest?.(selector);
    if (!root) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    purchase(root);
  }, true);
  document.addEventListener('shopify:section:load', updateAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', updateAll, {once:true});
  else updateAll();
})();